module.exports = __webpack_public_path__ + "static/media/favicon.b6b4b4be.ico";


//////////////////
// WEBPACK FOOTER
// ./src/contents/images/favicon.ico
// module id = 194
// module chunks = 0